import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Text } from '@solvhealth/jigsaw-v1';
import DateTime from '../../../../DateTime';
import {
  getRelativeDayName,
  getRelativeDayString,
  getTimeZoneFormat,
} from '../../../../../core/util/date';
import { EN, SupportedLocale } from '../../../../../core/util/localizedStr';

const Root = styled.div.withConfig({ componentId: 'sc-6thc7n-0' })`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

const TimeZoneFormat = styled.span.withConfig({ componentId: 'sc-6thc7n-1' })`
  margin-left: 5px;
`;

type Props = {
  isMoreDate: boolean;
  selectedDate: any;
  timeZone: string;
  locale?: SupportedLocale;
};

const Day = ({ isMoreDate, selectedDate, timeZone, locale = EN }: Props) => {
  const { t } = useTranslation();
  const relativeDay = getRelativeDayName(selectedDate, timeZone);
  return (
    <Root>
      <Text variant="h4">
        {`${getRelativeDayString(relativeDay, t)}, ${DateTime.format(selectedDate, timeZone, {
          locale,
        })(t('dtFormat.monthAndDate'))}`}

        <TimeZoneFormat>{`(${getTimeZoneFormat(timeZone)})`}</TimeZoneFormat>
      </Text>
    </Root>
  );
};

export default Day;
